// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_style_title__39mA8","left":"Title_style_left__3BRY1","right":"Title_style_right__IpS9M"};